import { emptySplitApi } from './injectApi';

const WHITELIST_PATH = '/sales-process/whitelist';

const whitelistApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    getWhitelist: build.query({
      query: () => ({
        url: WHITELIST_PATH,
        method: 'GET',
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Whitelist'],
    }),
    addWhitelist: build.mutation({
      query: ({ pinCode, esim = false, physicalSim = false }) => ({
        url: WHITELIST_PATH,
        method: 'POST',
        data: { pinCode, esim, physicalSim },
      }),
      invalidatesTags: ['Whitelist'],
    }),
    activateWhitelist: build.mutation({
      query: (pin) => ({
        url: `${WHITELIST_PATH}/${encodeURIComponent(pin)}/activate`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Whitelist'],
    }),
    deactivateWhitelist: build.mutation({
      query: (pin) => ({
        url: `${WHITELIST_PATH}/${encodeURIComponent(pin)}/deactivate`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Whitelist'],
    }),
    deleteWhitelist: build.mutation({
      query: (pin) => ({
        url: `${WHITELIST_PATH}/${encodeURIComponent(pin)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Whitelist'],
    }),
  }),
});

export const whitelistApiHooks = {
  useGetWhitelist: whitelistApi.useGetWhitelistQuery,
  useAddWhitelist: whitelistApi.useAddWhitelistMutation,
  useActivateWhitelist: whitelistApi.useActivateWhitelistMutation,
  useDeactivateWhitelist: whitelistApi.useDeactivateWhitelistMutation,
  useDeleteWhitelist: whitelistApi.useDeleteWhitelistMutation,
};
